import { Outlet } from 'react-router-dom';

/**
 * AuthLayout - Simple pass-through layout for auth pages
 * Each auth page (LoginPage, SignupPage, etc.) has its own complete layout
 * with the wave pattern on the right side as per Figma design
 */
export default function AuthLayout() {
  return <Outlet />;
}
